import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function CommentIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M4.75 2C3.2334 2 2 3.21777 2 4.71387V22.5615L5.92236 20H19.25C20.7666 20 22 18.7822 22 17.2861V2H4.75ZM20 17.2861C20 17.6797 19.6636 18 19.25 18H5.32764L4 18.8662V4.71387C4 4.32032 4.33643 4 4.75 4H20V17.2861ZM16 10H8V8H16V10ZM14 14H8V12H14V14Z",
    fill: "currentColor"
  }));
}